import { PrintGuide, Trip } from '../../../../../core';
import { DataTable } from '../../data-table.interface';
const iconsOfActionsList = [

  {
    icon: 'printer',
    tooltip: '',
    dropdown: [
      { text: 'Imprimir guía electrónica', value: 'PMM' },
      { text: 'Imprimir por CUPS', value: 'CUPS' }
    ],
    hasVisibleCondition: (element: PrintGuide[]): boolean => {
      return element && element.length == 1;
    }
  },
  {
    icon: 'printer',
    tooltip: '',
    dropdown: [
      { text: 'Imprimir por CUPS', value: 'CUPS' }
    ],
    hasVisibleCondition: (element: PrintGuide[]): boolean => {
      return element && element.length > 1;
    }
  }
];
export const guidePrint:DataTable = {
  searchText: 'Buscar despacho',
  addText: '',
  export: false,
  filter: false,
  filterDefault: '',
  showIcon: './assets/icon/ico_placeholder_documentos.svg',
  checkbox: true,
  checkboxHeader: true,
  alterColumns: false,
  iconsOfActions: iconsOfActionsList,
  paginator: true,
  
  columns: [
    {
      title: 'Cód. guía',
      name: 'guideCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.guideNumber
    },
    {
      title: 'Cód. de despacho',
      name: 'dispatchCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.dispatchNumber
    },
    {
      title: 'Origen',
      name: 'origin',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.entityName
    },
    {
      title: 'Destino',
      name: 'destiny',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.destiny
    },
    {
      title: 'Razón social',
      name: 'name',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.reasonSocial
    },
    {
      title: 'Transportista',
      name: 'carrier',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.carrier
    },
    {
      title: 'Placa',
      name: 'licensePlate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.plateNumber
    },
    {
      title: 'Motivo de despacho',
      name: 'motive',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: PrintGuide) => element.motive
    }
  ]
};

export const reasonGuidePrint = {
  columns: [
    {
      title: 'Cód. de viaje',
      name: 'id',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Trip) => element.id
    },
    {
      title: 'Sucursal de despacho',
      name: 'entityName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Trip) => element.entityName
    },
    {
      title: 'Fecha de entrega',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: any) => element.deliveryDate
    },
    {
      title: 'Estado de guía',
      name: 'guiaState',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Trip) => element.guiaState
    },
    {
      title: 'Motivo de impresión',
      name: 'reasonPrint',
      type: 'select',
      editable: true,
      checkAll: false,
      class: 'left',
      placeholderHidden: true,
      value: (element: any) => element.reasonPrint
    }
  ]
};

export const reasonGuidePrintDispatch = {
  show: 'Los despachos seleccionados ya fueron impresas',
  columns: [
    {
      title: 'Destino',
      name: 'zoneName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: any) => `${element.dispatchItems.nextEntity} - ${element.dispatchItems.nextEntityName}`
    },
    {
      title: 'Motivo de impresión',
      name: 'reasonPrint',
      type: 'select',
      editable: true,
      checkAll: false,
      class: 'left',
      placeholderHidden: true,
      value: (element: any) => element.reasonPrint
    }
  ]
};

